import React, { useEffect, useState } from "react";
import {
  Button,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Paper,
} from "@mui/material";

import { Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import {
  createSearchParams,
  Link as LinkRRD,
  useNavigate,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { appListAction } from "../../redux/toolkit/apps/list";
import EditIcon from "@mui/icons-material/Edit";
import NoDataFound from "../../common/NoDataFound";
import LoadingUI from "../../common/LoadingUI";
import Avatar from "@mui/material/Avatar";
import DeleteApp from "./DeleteApp";
import ActivateApp from "./ActivateApp";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import { sendOptToDeleteAppAction } from "../../redux/toolkit/apps/sendOtpToDeleteApp";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
function List() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [publisher_id, setPublisher_id] = useState();
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  const [ativeFilter, setActiveFilter] = useState(false);
  const [deleteApp, setDeleteApp] = useState(false);
  const [activateApp, setActivateApp] = useState(false);
  const [appId, setAppId] = useState();
  const [is_deleted, setIs_deleted] = useState();
  const [catMenu, setCatMenu] = useState(false);
  const [anchorCatMenu, setAnchorCatMenu] = useState();
  const [open, setOpen] = React.useState(false);

  const appLists = useSelector((state) => state.appLists);
  const { status, data, loading: listLoading, totalPages } = appLists;

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };


  const otpSendResponse = useSelector((state) => state.optToDeleteApp);
  const { status: otpStatus, data: otpData, loading: otpLoading } = otpSendResponse;

  const getAllDeletedApp = () => {
    setCatMenu(false);
    dispatch(appListAction({ is_deleted: true, page: pageState.page, limit: pageState.pageSize }));
    setActiveFilter(false);
  }

  const getNonDeletedApp = () => {
    setActiveFilter(false);
    dispatch(appListAction({ is_deleted: false, page: pageState.page, limit: pageState.pageSize }));
    setActiveFilter(false);
  }


  useEffect(() => {
    dispatch(appListAction({ is_deleted: false, page: pageState.page, limit: pageState.pageSize }));
  }, [pageState.page, pageState.pageSize, dispatch]);

  const AppColumns = [
    {
      field: "s_no",
      headerName: "S. NO.",
      filterable: false,
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => params?.api?.getRowIndex(params.row._id) + 1,
    },
    {
      field: "_id",
      headerName: "Id",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",

    },

    {
      field: "app_name",
      headerName: "App Name",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "app_logo",
      headerName: "App Logo",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Avatar sizes="small" alt="App logo" src={params?.row?.app_logo} />;
      },
    },


    {
      field: "is_verify",
      headerName: "Is Verify",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return params?.row?.is_verify ? <Chip label="Verified" color="success" variant="contained" /> : <Chip label="Not Verified" color="error" variant="contained" />;
      },
    },

    {
      field: "edit",
      headerName: "Edit App",
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              navigate({
                pathname: `/apps/update-app`,
                search: createSearchParams({
                  app_id: params?.row?._id,
                }).toString(),
              });
            }}
          >
            <EditIcon  />
          </IconButton>
        );
      },
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      hide: ativeFilter,
    },
    {
      field: "delete",
      headerName: "Delete App",
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteApp(true);
              // setIs_deleted(true);
              setPublisher_id(params?.row?.publisher_id)
              setAppId(params?.row?._id);
              dispatch(sendOptToDeleteAppAction({ publisher_id: params?.row?.publisher_id }));
            }}
          >
            <DeleteIcon color="error" />
          </IconButton>
        );
      },
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      hide: ativeFilter
    },

    // {

    //   field: 'secret_key', headerName: 'Secret Key',
    //   renderCell: (params) => {
    //     return (
    //       <>
    //         <div>
    //           <p>{params?.row?.secret_key}</p>
    //           <CopyToClipboard text={params?.row?.secret_key} >
    //             <Button onClick={handleClick}>copy</Button>
    //           </CopyToClipboard>
    //         </div>
    //       </>

    //     )
    //   },
    //   minWidth: 250,
    //   headerClassName: 'super-app-theme--header',
    //   hide: ativeFilter
    // },
  ];

  return (
    <>
      <Stack direction="row" justifyContent="flex-end" alignItems="flex-end" gap={4}>
        {
          <IconButton
            onClick={(event) => {
              setCatMenu(true);
              setAnchorCatMenu(event.currentTarget);
            }}
          >
            <FilterAltIcon color="#071D45" />
          </IconButton>
        }

        <Menu
          open={catMenu}
          onClose={() => setCatMenu(false)}
          anchorEl={anchorCatMenu}
        >
          <MenuItem
            selected={ativeFilter}
            onClick={() => {
              getAllDeletedApp();

            }}
          >
            Deleted
          </MenuItem>
          <MenuItem
            selected={!ativeFilter}
            onClick={() => {
              getNonDeletedApp()
            }}
          >
            Non Deleted
          </MenuItem>
        </Menu>

        <Button
          variant="contained"

          sx={{
            // textTransform: "none",
            // background:" linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)"
            background:"#000",
            '&:hover':{
              background:"#000"
            }
          }}
          endIcon={<AddIcon />}
          onClick={() => {
            navigate("/apps/create-app");
          }}
        >
        Create App
        </Button>
      </Stack>

      <Paper
        sx={{
          marginTop: 2,
                bgcolor: '#fff',
                '& .super-app-theme--header': {
                    background: "rgba(254, 206, 113, 0.16)",
                    color: "#000",
                    borderBottom:" 1px solid #000",
                    fontFamily: "Open Sans",
                    fontSize: "13px",
                },
        }}
        elevation={0}
      >
        <DataGrid
          getRowHeight={({ densityFactor }) => {
            return 70 * densityFactor;
        }}
          sx={{
            border:" 1px solid #000",
            "& .MuiDataGrid-row:hover": {
                background: "rgba(254, 206, 113, 0.16)",
                cursor: "pointer",
            }
        }}
          autoHeight
          rows={data}
          columns={AppColumns}
          getRowId={(row) => row._id}
          disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
          rowsPerPageOptions={[25, 50, 100]}
          pagination
          paginationMode="server"
          rowCount={totalPages} 
          paginationModel={{ page: pageState.page, pageSize: pageState.pageSize }}
          onPageChange={(newPage) => setPageState((prev) => ({ ...prev, page: newPage }))}
          onPageSizeChange={(newPageSize) => setPageState((prev) => ({ ...prev, pageSize: newPageSize }))}
          disableColumnSelector
          loading={listLoading ? <LoadingUI /> : false}
          onCellClick={(params) => {
            setPublisher_id(params?.row?.publisher_id);
          }}
          components={{
            NoRowsOverlay: () => <NoDataFound />,
          }}
        />
      </Paper>


      <DeleteApp
        appId={appId}
        state={deleteApp}
        publisher_id={publisher_id}
        setState={setDeleteApp}
      />
      <ActivateApp
        appId={appId}
        state={activateApp}
        setState={setActivateApp}
      />
      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          Copied!
        </Alert>
      </Snackbar>
    </>
  );
}

export default List;
